(function(){
  function init(root){
    if(!root||root.dataset.mrhReady==='true')return;
    root.dataset.mrhReady='true';

    var navLinks=[].slice.call(root.querySelectorAll('.mrh-sidebar a'));
    var sections=[].slice.call(root.querySelectorAll('[data-mrh-section]'));
    if('IntersectionObserver' in window&&navLinks.length&&sections.length){
      var byId={};
      navLinks.forEach(function(link){byId[link.getAttribute('href').slice(1)]=link;});
      var observer=new IntersectionObserver(function(entries){
        var visible=entries.filter(function(entry){return entry.isIntersecting;}).sort(function(a,b){return b.intersectionRatio-a.intersectionRatio;})[0];
        if(!visible)return;
        navLinks.forEach(function(link){link.classList.remove('is-active');link.removeAttribute('aria-current');});
        if(byId[visible.target.id]){byId[visible.target.id].classList.add('is-active');byId[visible.target.id].setAttribute('aria-current','true');}
      },{rootMargin:'-20% 0px -64% 0px',threshold:[0,.1,.35]});
      sections.forEach(function(section){observer.observe(section);});
    }

    // Keep the landing page compact, then reveal one focused procedure at a time.
    var guides=[].slice.call(root.querySelectorAll('[data-mrh-guide]'));
    var reducedMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function linksForSection(section){
      return [].slice.call(root.querySelectorAll('a[href="#'+section.id+'"]'));
    }
    function syncGuideState(section,guide){
      section.classList.toggle('is-selected',guide.open);
      linksForSection(section).forEach(function(link){link.setAttribute('aria-expanded',guide.open?'true':'false');});
    }
    function openGuideSection(section,shouldScroll){
      var guide=section&&section.querySelector('[data-mrh-guide]');
      if(!guide)return false;
      guides.forEach(function(other){if(other!==guide)other.open=false;});
      guide.open=true;
      syncGuideState(section,guide);
      if(shouldScroll)setTimeout(function(){section.scrollIntoView({behavior:reducedMotion?'auto':'smooth',block:'start'});},20);
      return true;
    }
    guides.forEach(function(guide,index){
      var section=guide.closest('[data-mrh-guide-section]');
      if(!section)return;
      if(!guide.id)guide.id=section.id+'-guide';
      linksForSection(section).forEach(function(link){link.setAttribute('aria-controls',guide.id);link.setAttribute('aria-expanded','false');});
      guide.addEventListener('toggle',function(){
        if(guide.open)guides.forEach(function(other){if(other!==guide)other.open=false;});
        syncGuideState(section,guide);
      });
    });
    [].slice.call(root.querySelectorAll('a[href^="#"]')).forEach(function(link){
      link.addEventListener('click',function(event){
        var id=link.getAttribute('href').slice(1);
        var section=id&&document.getElementById(id);
        if(section&&root.contains(section)&&section.hasAttribute('data-mrh-guide-section')){
          event.preventDefault();
          if(history.pushState)history.pushState(null,'','#'+id);else location.hash=id;
          openGuideSection(section,true);
        }
      });
    });
    if(location.hash){
      var initialSection=document.getElementById(location.hash.slice(1));
      if(initialSection&&root.contains(initialSection)&&initialSection.hasAttribute('data-mrh-guide-section'))openGuideSection(initialSection,false);
    }

    function copyGuide(text){
      if(navigator.clipboard&&navigator.clipboard.writeText)return navigator.clipboard.writeText(text);
      return new Promise(function(resolve,reject){
        var field=document.createElement('textarea');
        field.value=text;field.setAttribute('readonly','');field.style.position='fixed';field.style.opacity='0';
        document.body.appendChild(field);field.select();
        try{document.execCommand('copy');resolve();}catch(error){reject(error);}
        document.body.removeChild(field);
      });
    }
    [].slice.call(root.querySelectorAll('[data-mrh-copy-guide]')).forEach(function(button){
      button.addEventListener('click',function(){
        var section=button.closest('[data-mrh-guide-section]');
        var source=section&&section.querySelector('[data-mrh-guide-copy-source]');
        var status=section&&section.querySelector('[data-mrh-guide-status]');
        if(!source)return;
        copyGuide(source.innerText.trim()).then(function(){
          if(status)status.textContent='Copied to clipboard.';
        }).catch(function(){
          if(status)status.textContent='Copy was unavailable. Select the steps and copy them manually.';
        });
      });
    });
    [].slice.call(root.querySelectorAll('[data-mrh-print-guide]')).forEach(function(button){
      button.addEventListener('click',function(){
        var section=button.closest('[data-mrh-guide-section]');
        if(!section)return;
        section.setAttribute('data-mrh-print-active','true');root.classList.add('is-printing-guide');
        var cleanup=function(){root.classList.remove('is-printing-guide');section.removeAttribute('data-mrh-print-active');};
        window.addEventListener('afterprint',cleanup,{once:true});
        setTimeout(function(){window.print();},20);
      });
    });

    [].slice.call(root.querySelectorAll('.mrh-mobile-jump a')).forEach(function(link){
      link.addEventListener('click',function(){var details=link.closest('details');if(details)details.open=false;});
    });

    var dialog=root.querySelector('.mrh-dialog');
    var form=root.querySelector('.mrh-form');
    var formView=root.querySelector('[data-mrh-form-view]');
    var success=root.querySelector('[data-mrh-success]');
    var status=root.querySelector('[data-mrh-status]');
    var submit=root.querySelector('[data-mrh-submit]');
    var lastTrigger=null;

    function closeDialog(){
      if(!dialog)return;
      if(typeof dialog.close==='function'&&dialog.open)dialog.close();
      else dialog.removeAttribute('open');
    }
    function openDialog(trigger){
      if(!dialog)return;
      lastTrigger=trigger||null;
      if(typeof dialog.showModal==='function')dialog.showModal();
      else dialog.setAttribute('open','');
      var first=form&&form.querySelector('input:not([type="hidden"])');
      if(first)setTimeout(function(){first.focus();},0);
    }
    [].slice.call(root.querySelectorAll('[data-mrh-dialog-open]')).forEach(function(trigger){
      trigger.addEventListener('click',function(event){event.preventDefault();openDialog(trigger);});
    });
    [].slice.call(root.querySelectorAll('[data-mrh-dialog-close]')).forEach(function(button){button.addEventListener('click',closeDialog);});
    if(dialog){
      dialog.addEventListener('click',function(event){if(event.target===dialog)closeDialog();});
      dialog.addEventListener('close',function(){if(lastTrigger&&lastTrigger.focus)lastTrigger.focus();});
    }
    if(form){
      form.addEventListener('submit',function(event){
        event.preventDefault();
        if(!form.checkValidity()){form.reportValidity();return;}
        if(status){status.hidden=true;status.textContent='';}
        if(submit){submit.disabled=true;submit.textContent='Sending…';}
        fetch(form.action,{method:'POST',body:new FormData(form),headers:{Accept:'text/html'}})
          .then(function(response){
            if(!response.ok||/challenge/i.test(response.url))throw new Error('Submission failed');
            if(formView)formView.hidden=true;
            if(success){success.hidden=false;var heading=success.querySelector('h2');if(heading)heading.focus();}
          })
          .catch(function(){if(status){status.textContent='We could not send your request. Please check your connection and try again.';status.hidden=false;}})
          .finally(function(){if(submit){submit.disabled=false;submit.textContent='Send request';}});
      });
    }
  }
  function initAll(scope){[].slice.call((scope||document).querySelectorAll('[data-model-resource-hub]')).forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);});else initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();
